import { getErrorMessage, isApiError } from './api.ts';

/**
 * F-37: the correlation id of a failed API call, if the failure carried one. Read from the
 * typed `ApiError` (the `x-request-id` response header, else the body's `request_id`);
 * `undefined` for transport failures and non-API errors. Shown beside the error message as a
 * "Reference" line so a client can quote it to support and support can find the request.
 */
export function getRequestId(err: unknown): string | undefined {
  return isApiError(err) ? err.requestId : undefined;
}

/** What an error surface renders: the safe message plus the optional reference (F-37). */
export interface ErrorInfo {
  message: string;
  requestId?: string | undefined;
}

/** The safe message + request id for a caught error, ready for `<ErrorState>`. */
export function describeError(err: unknown): ErrorInfo {
  const requestId = getRequestId(err);
  return requestId
    ? { message: getErrorMessage(err), requestId }
    : { message: getErrorMessage(err) };
}
